import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";

export const ResetFilterState: Handler = props => {
    (props as unknown as any).dispatch({
            type: "Custom/OrderHistory/ResetFiltersOpen",
    });
};

export const chain = [ResetFilterState];

const resetFilterState = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetFilterState");
export default resetFilterState;
